import { XIcon } from 'components/ui/icons';
import TextField from 'components/ui/TextField';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { Icon, Loader } from 'semantic-ui-react';
import BkInfoModal from './AutomateNames/BkSearchComponents/BkInfoModal';
import produce from 'immer';
import axios from 'axios';
import PatriotInfoModal from './AutomateNames/PatriotSearchComponents/PatriotInfoModal';
import { NameToSearch } from './AutomateNamesTypes';
import { NameToAutomate } from './AutomateNames/NameToAutomate';

interface PropTypes {
  bkDistrict: string;
  searchTypeId: number;
  orderId: number;
  propertyId: number;
  searchId: number;
}

const generateDefaultNameToSearch = () => {
  return {
    id: Math.random(),
    firstName: '',
    middleName: '',
    lastName: '',
    loading: false,
    ran: false,
    failed: false,
  };
};

export const AutomateNames = (props: PropTypes) => {
  const [namesToAutomate, setNamesToAutomate] = useState<NameToSearch[]>([generateDefaultNameToSearch()]);
  const [openResultsModal, setOpenResultsModal] = useState(false);
  const [bkReportInfo, setBkReportInfo] = useState({ data: { foundNames: [], courtId: '' } });
  const [patriotReportInfo, setPatriotReportInfo] = useState({ data: { foundNames: [] } });
  const searchUrl = `/api/automation/${
    props.searchTypeId === 35 ? 'runBkAutomation' : 'runPatriotAutomation'
  }`;

  const handleDelete = async (indexToRemove: number) => {
    const newNamesToAutomate = namesToAutomate.filter((tl, index) => index !== indexToRemove);
    setNamesToAutomate(newNamesToAutomate);
  };

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>, label: string, id: number) => {
    const nextState = produce(namesToAutomate, draft => {
      const thisOne = draft.find(x => x.id === id);
      (thisOne as any)[label] = event.target.value;
    });
    setNamesToAutomate(nextState);
  };

  const handleRunAutomation = async () => {
    const next = produce(namesToAutomate, draft => {
      draft.map(d => {
        d.loading = true;
        d.ran = false;
      });
    });

    setNamesToAutomate(next);

    const data = await axios.post(searchUrl, {
      namesToRun: namesToAutomate,
      orderId: props.orderId,
      bkDistrict: props.bkDistrict,
      propertyId: props.propertyId,
      searchId: props.searchId,
    });
    setOpenResultsModal(true);
    const next2 = produce(namesToAutomate, draft => {
      draft.map(d => {
        d.ran = true;
        d.loading = false;
        d.failed = data.status !== 200 || !data.data;
      });
    });
    setNamesToAutomate(next2);
    if (props.searchTypeId === 35) {
      setBkReportInfo(data);
    } else {
      setPatriotReportInfo(data);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span
          style={{
            marginBottom: 8,
            marginTop: 32,
            fontWeight: 'bold',
            display: 'inline-block',
          }}
        >
          Names To Automate
        </span>
        {namesToAutomate?.map((na, idx) => {
          return (
            <>
              <NameToAutomate
                name={na}
                idx={idx}
                handleNameChange={handleNameChange}
                handleDelete={handleDelete}
              />
              {openResultsModal && props.searchTypeId === 35 && (
                <BkInfoModal
                  openState={openResultsModal}
                  onClose={() => setOpenResultsModal(false)}
                  info={bkReportInfo.data}
                />
              )}
              {openResultsModal && props.searchTypeId === 36 && (
                <PatriotInfoModal
                  openState={openResultsModal}
                  onClose={() => setOpenResultsModal(false)}
                  info={patriotReportInfo.data}
                />
              )}
            </>
          );
        })}
        <div style={{ display: 'flex', marginTop: 16 }}>
          <div
            style={{ display: 'flex', color: 'red', cursor: 'pointer' }}
            onClick={() => {
              const next = produce(namesToAutomate, draft => {
                draft.push(generateDefaultNameToSearch());
              });
              setNamesToAutomate(next);
            }}
          >
            <Icon name="plus" />
            Add Names
          </div>
          {namesToAutomate.length > 1 && (
            <div
              onClick={() => setNamesToAutomate([generateDefaultNameToSearch()])}
              style={{ color: '#333', cursor: 'pointer', marginLeft: 40, fontWeight: 'bold' }}
            >
              Clear All Names
            </div>
          )}
        </div>
      </div>
      <div style={{ display: 'flex' }}>
        <div
          style={{
            border: '1px solid #E5E5EA',
            borderRadius: '10px',
            width: 'fit-content',
            padding: '8px 16px',
            height: 'fit-content',
            marginTop: 10,
            cursor: 'pointer',
          }}
          onClick={() => handleRunAutomation()}
        >
          Search Records
        </div>
        {(bkReportInfo.data.foundNames?.length > 0 || patriotReportInfo.data.foundNames?.length > 0) && (
          <div
            style={{
              border: '1px solid #E5E5EA',
              borderRadius: '10px',
              width: 'fit-content',
              padding: '8px 16px',
              height: 'fit-content',
              marginTop: 10,
              cursor: 'pointer',
              marginLeft: 8,
            }}
            onClick={() => setOpenResultsModal(true)}
          >
            See Results
          </div>
        )}
      </div>
    </div>
  );
};
